import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import {
  checklistModelToCreateGraphql,
  createChecklist,
} from '@akin-home/checklists';
import {
  checklistKeys,
  createTaskListMutation,
} from '@akin-home/checklists/frontend';
import { z } from 'zod';
import { createOutputTextItem } from '../../ChatItem/functions';
import { CreateChecklistCommand } from '../schemas';

const Params = z.object({
  user_id: z.string(),
  habitatID: z.string(),

  data: CreateChecklistCommand.shape.data,
});

type Params = z.infer<typeof Params>;

export const createChecklistCommand = (params: Params) => {
  const result = Params.safeParse(params);

  if (!result.success) {
    return { error: result.error };
  }

  const { data } = result;

  const {
    user_id,
    habitatID,
    data: { success_message, error_message, ...checklist_data },
  } = data;

  return {
    success_message,
    checklist: createChecklist({
      habitatID,
      principalID: user_id,
      participantIDs: [user_id],
      ...checklist_data,
    }),
  };
};

export const handleCreateChecklistCommand = async (params: Params) => {
  const { checklist, success_message, error } = createChecklistCommand(params);

  const { addChatItem, query_client } = useStateStore.getState();

  if (checklist) {
    try {
      await createTaskListMutation({
        input: checklistModelToCreateGraphql(checklist),
      });

      query_client.invalidateQueries(checklistKeys.lists());

      addChatItem(
        createOutputTextItem(
          success_message || 'Done, I have created that checklist for you.'
        )
      );
    } catch (ex) {
      addChatItem(
        createOutputTextItem(
          params.data.error_message ||
            "Sorry, I couldn't create that checklist for you."
        )
      );
    }
  } else if (error) {
    addChatItem(
      createOutputTextItem(
        params.data.error_message ||
          "Sorry, I couldn't create that checklist for you."
      )
    );
  }
};
